module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtMasterMsspThree.ddbf6e2.png";